// extracted by mini-css-extract-plugin
export default {"loaderContent":"Loader_loaderContent__93FkL","loader":"Loader_loader__+lRPl"};